import { connect } from 'react-redux';
import { CaseGlobalViewPage } from './CaseGlobalViewPage';
import { withI18nExist } from 'src/shared/helpers/pagesHelpers';
import { getI18n, getIdentityConfiguration, getAutoPlayInactivityDelays } from 'src/redux/core/coreSelectors';
import { getCaseDocumentWidgetTab, getCurrentCaseInformation, getCurrentCaseOverviewInfo, getCurrentCaseDocumentsEnhanced, getCurrentCaseActions, getNBStatusRecapOfDocument, getCaseContracts, getCurrentCaseComments, getCurrentCaseLock, getCurrentCaseActionModalContent, getCurrentCaseActionModalIsLoading, getModalCache, getCurrentCaseKycSessions, getCurrentCaseApplicants, getCurrentApplicant, getCurrentUpdatedDocumentData, getAutoPlay, } from 'src/redux/cases/casesSelectors';
import { casesActions } from 'src/redux/cases/casesActions';
import { coreActions } from 'src/redux/core/coreActions';
import { getCommentsPermission, getIsCasesViewAllowed } from 'src/redux/auth/authSelectors';
var mapStateToProps = function (state) { return ({
    i18n: getI18n(state),
    information: getCurrentCaseInformation(state),
    documentWidgetTab: getCaseDocumentWidgetTab(state),
    overviewInfo: getCurrentCaseOverviewInfo(state),
    documents: getCurrentCaseDocumentsEnhanced(state),
    documentNbStatusRecap: getNBStatusRecapOfDocument(state),
    actions: getCurrentCaseActions(state),
    actionsModal: getCurrentCaseActionModalContent(state),
    actionsModalIsLoading: getCurrentCaseActionModalIsLoading(state),
    currentApplicant: getCurrentApplicant(state),
    applicants: getCurrentCaseApplicants(state),
    contracts: getCaseContracts(state),
    comments: getCurrentCaseComments(state),
    kycSessions: getCurrentCaseKycSessions(state),
    lock: getCurrentCaseLock(state),
    identityConfiguration: getIdentityConfiguration(state),
    modalCache: getModalCache(state),
    isCommentDisplayed: getCommentsPermission(state),
    updatedDocumentData: getCurrentUpdatedDocumentData(state),
    autoPlay: getAutoPlay(state),
    isCasesViewAllowed: getIsCasesViewAllowed(state),
    autoPlayInactivityDelays: getAutoPlayInactivityDelays(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    cancelFetchFiles: function () { return dispatch(coreActions.addFilesUrlsCancelled()); },
    updateCurrentApplicants: function (newApplicantId) { return dispatch(casesActions.updateCurrentApplicants(newApplicantId)); },
    updateDocStatus: function (product, productToken, document, status) {
        return dispatch(casesActions.updateDocStatusRequested(product, productToken, document, status));
    },
    makeCaseActionTaskRequested: function (decision) {
        return dispatch(casesActions.makeCaseActionTaskRequested(decision));
    },
    closeActionModal: function () { return dispatch(casesActions.updateActionModal(null)); },
    confirmDecisionModal: function (params) { return dispatch(casesActions.confirmDecisionModalRequested(params)); },
    fetchContractsRequested: function () { return dispatch(casesActions.fetchContractsRequested()); },
    fetchContractsSucceeded: function (contractsBundles) {
        return dispatch(casesActions.fetchContractsSucceeded(contractsBundles));
    },
    downloadContract: function (contract) { return dispatch(casesActions.downloadContract(contract)); },
    sendComment: function (product, productToken, comment) {
        return dispatch(casesActions.sendCommentRequested(product, productToken, comment));
    },
    downloadFileUrlRequested: function (fileUrl) { return dispatch(casesActions.downloadFileUrlRequested(fileUrl)); },
    updateModalIncompleteParamsRequested: function (incompleteParams) {
        return dispatch(casesActions.updateModalIncompleteParamsRequested(incompleteParams));
    },
    updateMrzLines: function (mrzLines) { return dispatch(casesActions.updateMrzLinesRequested(mrzLines)); },
    updateFileUrlSource: function (url, sources, sourceIndex) {
        return dispatch(coreActions.updateFileUrlSource(url, sources, sourceIndex));
    },
    updateAutoPlay: function (value) { return dispatch(casesActions.updateAutoPlay(value)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(withI18nExist(CaseGlobalViewPage));
